import { KnmDataViolationPathsTemplateEnum } from 'APIPackage/KnmModule/enums/KnmDataViolationPathsTemplateEnum';
import { DATE_FORMAT_LONG_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { formatDateLocale } from 'CorePackage/MainModule/common/formatDate';
import { checkObjWithNameProp } from 'CorePackage/MainModule/common/checkObjWithNameProp';

import { IKnmDataViolationExtended } from '../interfaces/IKnmDataViolationExtended';

interface IObjWithFullName {
  fullName: string;
}
interface IObjWithName {
  name: string;
}

export const renderViolationValue = (violation: IKnmDataViolationExtended) => {
  let value: unknown | string = '';

  if (typeof violation.value === 'string') {
    if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.DATE ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.START_DATE ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.STOP_DATE ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_ACT_CREATE_DATE ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_START_DATE
    ) {
      value = formatDateLocale({ date: violation.value, dateFormat: DATE_FORMAT_LONG_FNS }) || '';
    } else {
      value = violation.value;
    }
  } else if (typeof violation.value === 'object') {
    if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.TYPE) {
      value = violation.value?.name;
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.KIND) {
      value = violation.value?.name;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.LEGAL_BASES ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.LEGAL_BASES_ITEM
    ) {
      value = violation.value?.documentName;
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.KNO_ORGANIZATION) {
      value = checkObjWithNameProp<IObjWithFullName>(violation.value?.organization, 'fullName')
        ? violation.value?.organization?.fullName
        : '';
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.SUPERVISION_TYPE) {
      value = violation.value?.name;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.EVENTS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.EVENTS_ITEM
    ) {
      value = violation.value?.name;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.FUNCTIONS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.FUNCTIONS_ITEM
    ) {
      value = violation.value?.fullName;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.INSPECTORS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.INSPECTORS_ITEM
    ) {
      value = violation.value?.fullName;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.OBJECTS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.OBJECTS_ITEM
    ) {
      value = violation.value?.address;
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.SUPERVISIONS) {
      value = checkObjWithNameProp<IObjWithName>(violation.value?.supervisionType, 'name')
        ? violation.value?.supervisionType?.name
        : '';
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT) {
      value = violation.value ? violation.value?.actAddress : violation.address;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_ADDITIONAL_INFO_ITEM
    ) {
      value = checkObjWithNameProp<IObjWithName>(violation.value?.type, 'name') ? violation.value?.type?.name : '';
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_DELEGATES_ITEM
    ) {
      value = violation.value?.fullName;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.RESULT_INSPECTORS_ITEM
    ) {
      value = violation.value?.fullName;
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.LAWSUITS) {
      value = checkObjWithNameProp<IObjWithName>(violation.value?.lawsuitType, 'name')
        ? violation.value?.lawsuitType?.name
        : '';
    } else if (violation.pathTemplate === KnmDataViolationPathsTemplateEnum.CHECKLISTS) {
      value = violation.value?.name;
    } else if (
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.REQUIREMENTS ||
      violation.pathTemplate === KnmDataViolationPathsTemplateEnum.REQUIREMENTS_ITEM
    ) {
      value = violation.value?.name;
    }
  }
  if (!value) {
    return;
  }

  return ` - ${value}`;
};
